import React from 'react';
import styled from 'styled-components';
import { LoadingFullScreen } from '/imports/ui/LoadingFullScreen';
import { useMethod } from '/imports/hooks';
import { getSolarBillForJwt } from '/imports/api/solarBills';
import { NorthshoreBill } from '/imports/ui/NorthshoreBill';
import { NorthshoreConsolidatedBill } from '/imports/ui/NorthshoreConsolidatedBill';
import { RealtyIncomeBill } from '/imports/ui/RealtyIncomeBill';

export const SolarBillViewPageStyled = styled.div`
`;

/** Public bill viewer that resolves a JWT-scoped solar bill and renders the issuer-specific layout. */
export const SolarBillViewPage = () => {
  const params = new URLSearchParams(location.search);
  const jwt = params.get('jwt');
  const billId = params.get('billId');
  const [bill, loading] = useMethod(getSolarBillForJwt, { billId, jwt });
  if (loading) return <LoadingFullScreen />;
  if (!bill) return null;
  let Component;
  if (bill.type === 'northshore') Component = <NorthshoreBill bill={bill} />;
  if (bill.type === 'northshoreConsolidated') Component = <NorthshoreConsolidatedBill bill={bill} />;
  if (bill.type === 'realtyIncome') Component = <RealtyIncomeBill bill={bill} />;
  return (
    <SolarBillViewPageStyled className="solar-bill">
      {Component}
    </SolarBillViewPageStyled>
  );
};